import { render } from "./Socks.vue?vue&type=template&id=355663d0"
import script from "./Socks.vue?vue&type=script&lang=js"
export * from "./Socks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__